export type LoungeRegion =
  | 'australia'
  | 'asia_pacific'
  | 'europe'
  | 'middle_east'
  | 'north_america'
  | 'south_america'
  | 'africa'

export const REGION_DISPLAY_NAMES: Record<LoungeRegion, string> = {
  australia: 'Australia',
  asia_pacific: 'Asia Pacific',
  europe: 'Europe',
  middle_east: 'Middle East',
  north_america: 'North America',
  south_america: 'South America',
  africa: 'Africa',
}

export const REGION_DISPLAY_ORDER: Array<LoungeRegion> = [
  'australia',
  'asia_pacific',
  'europe',
  'middle_east',
  'north_america',
  'south_america',
  'africa',
]
